import React from 'react'
import { thankyouIcon } from '../../assets/images'
import { useNavigate, useParams } from 'react-router-dom';

export default function SuccessPage() {
    const navigate = useNavigate();
    const {recorded} = useParams();
  return (
    <div className="customContainer thankyouPage headingTexts mt-4">
      <div className="thankyouDetails text-center">
        <div className="form-group">
          <img src={thankyouIcon} alt="" className="thankyouIcon" />
        </div>
        <h2>{recorded.toString() === '1' ? "Data Already Recorded." : "Data Updated Successfully!"}</h2>
        <p style={{ fontWeight: "300" }}>
          {recorded.toString() === '1' ? "Your data is already recorded" :"Your data successfully updated!"}
        </p>
        <div>
          <button
            onClick={() => {navigate("/", { replace: true })}}
            className="btn btn-primary"
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  )
}
